import React, { HTMLAttributes } from 'react';
import {
  useDraggableContainer,
  UseDraggableContainerProps,
} from './useDraggableContainer';
import classNames from 'classnames';

export interface DraggableContainerProps
  extends Omit<
      HTMLAttributes<HTMLDivElement>,
      keyof UseDraggableContainerProps
    >,
    UseDraggableContainerProps {
  dataHook?: string;
}

export function DraggableContainer(props: DraggableContainerProps) {
  const {
    dataHook,
    className,
    draggable,
    dragging,
    dragDisabled,
    dim,
    ...rest
  } = props;
  const { className: draggableClassName } = useDraggableContainer({
    draggable,
    dragging,
    dragDisabled,
    dim,
  });
  return (
    <div
      data-hook={dataHook}
      className={classNames(className, draggableClassName)}
      {...rest}
    />
  );
}
